import { usePermissions } from 'react-admin';
import { ComponentType, FC } from 'react';

// components
import DashboardTravelAgent from '../tours-agent/dashboard/DashboardTravelAgent';
import RentalDashboard from '../rental/dashboard/Dashboard';
import DashboardCommissionPartner from '@/tours-agent/dashboard/DashboardCommissionPartner';
import Dispatch from '@/taxi-dispatch/dispatch/Dispatch';
import ServiceDashboard from '@/garageManagment/dashboard/Dashboard';

const dashboardConfig: Record<string, Record<string, ComponentType>> = {
    taxi: {
        owner: Dispatch,
        operator: Dispatch,
        commission_partner: Dispatch,
    },
    company: {
        owner: DashboardTravelAgent,
        operator: DashboardTravelAgent,
    },
    transportation_agency: {
        owner: DashboardTravelAgent,
        commission_partner: DashboardCommissionPartner,
    },
    rental: {
        owner: RentalDashboard,
        commission_partner: RentalDashboard,
    },
    auto_service: {
        owner: ServiceDashboard
    },
    logistics: {
        owner: Dispatch
    }
};

const Dashboard: FC = () => {
    const { permissions } = usePermissions();
    const { settings_type = 'taxi', user_role = 'operator' } = permissions || {};

    const SelectedDashboard: ComponentType = dashboardConfig[settings_type]?.[user_role] || null;
    if (!SelectedDashboard) return;
    return <SelectedDashboard />;
};

export default Dashboard;